import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const pedidoCertidaoInteiroTeorSuplementarConfig = {
  id: 'pedido_certidao_inteiro_teor_suplementar',
  nome: 'Certidão de Inteiro Teor - Suplementar',
  descricao: 'Solicitação de Certidão de Inteiro Teor Suplementar junto à OAB/MS',
  icon: 'FaCertificate',

  documentConfig: {
    required: []
  },

  paymentConfig: {
    amount: 27.00
  },

  // modeloRequerimento/tiposAssunto/tipoPedido/tipoLancamentoId: códigos
  // externos (APIs de Protocolo e Títulos) informados diretamente pelo dono do
  // catálogo, não deduzidos nem reaproveitados de outro pedido.
  protocoloConfig: {
    modeloRequerimento: '248',
    tiposAssunto: '349',
    tipoPedido: '386'
  },

  tituloConfig: {
    tipoLancamentoId: 45,
    enderecoOrigem: 'residencial'
  },

  // `informacoesAdicionais` (ver steps abaixo) é só de UI por enquanto — de
  // propósito NÃO entra aqui em dadosRequerimentoConfig.campos. O usuário (dono
  // do catálogo) ainda precisa alterar a API de Protocolo pra aceitar esse campo
  // e definir onde ele fica salvo no banco; até lá, o texto só aparece no Resumo
  // do Requerimento em PDF (gerado a partir de config.steps genericamente, ver
  // resumoRequerimentoService.js), pro departamento ler na hora de gerar a
  // certidão manualmente.
  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' },
        { field: 'emailComercial', campoNome: 'EmailComercial' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
  ),

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { type: 'text', name: 'nomeCompleto', label: 'Nome completo', required: true, placeholder: 'Digite seu nome completo' },
            { type: 'cpf', name: 'cpf', label: 'CPF', required: true },
            { type: 'email', name: 'emailComercial', label: 'E-mail Comercial', required: false, placeholder: 'email@exemplo.com' }
          ]
        }
      ]
    },
    enderecoStep({ autoCep: true, comEnderecoEmSeuNome: false }),
    {
      id: 'informacoes_adicionais',
      title: 'Informações Adicionais',
      sections: [
        {
          title: 'Informações Adicionais',
          fields: [
            {
              type: 'textarea',
              name: 'informacoesAdicionais',
              label: 'Informações adicionais (opcional)',
              required: false,
              placeholder: 'Se desejar, escreva aqui informações que possam ajudar na geração da certidão',
              rows: 4
            }
          ]
        }
      ]
    },
    termosStep()
  ]
};

export default pedidoCertidaoInteiroTeorSuplementarConfig;
